var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.getBgColor + " bg-opacity-50 " + _vm.getTextColor + " fd-w-full fd-inline fd-py-1.5 fd-px-5 fd-text-xs fd-rounded-full fd-font-normal"),staticStyle:{"min-width":"80px"}},[_vm._v(" "+_vm._s(_vm.label || _vm.status)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }